import MainLayout from '../components/MainLayout'
import { Box, Grid, Typography } from '@mui/material'

import banner from '../assets/about/00公司簡介BN.png'
import imgAbout from '../assets/about/01關於慧智瞳.jpg'
import ContactMe from '../components/ContactMe'
import styled from '@emotion/styled'
import useRwd from '../utils/useRwd'

const StyledBox = styled(Box)`
  margin: 2em;
`
const StyleSpan = styled.span`
  font-family: GenYOGothic2TW;
  font-weight: bold;
  color: #045ea8;
`

export default function About() {
  const { isPhone, isPC } = useRwd()
  return (
    <MainLayout bannerFile={banner} bannerAlt="公司簡介">
      <Grid container spacing={10} textAlign="center">
        <Grid item xs={12}>
          <img src={imgAbout} alt="關於慧智瞳" style={{ width: '100%' }} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3">關於慧智瞳</Typography>
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              backgroundColor: '#f7f7f7',
              padding: isPhone ? '1em 0.5em' : '2em 4em',
            }}
          >
            <StyledBox>
              <Typography variant="h4" style={{ marginBottom: '0.5rem' }}>
                AI 影像辨識專家，助力企業邁向智慧未來
              </Typography>
              <Typography variant="body1" align="justify">
                慧智瞳科技（AIEye Tech）專注於 AI
                影像辨識技術的研發與應用，致力於為製造業與安全管理領域提供高效、精準的智慧解決方案。我們的核心技術涵蓋
                AI
                視覺檢測、深度學習演算法、邊緣運算與工業自動化應用，幫助企業提升生產效率、優化品質管理，並強化作業安全。
              </Typography>
              <Typography
                variant="body1"
                align="justify"
                style={{ marginTop: '0.4em' }}
              >
                我們的 AI
                產品已成功應用於多個產業，包括電子製造、金屬加工、食品檢測、醫療防護與智慧工廠等，透過高精度影像辨識技術，協助客戶大幅降低人工檢測誤差，提升產線標準化與自動化能力。
              </Typography>
            </StyledBox>
            <StyledBox>
              <Typography
                variant="subtitle1"
                style={{ marginBottom: '0.5rem' }}
              >
                我們的使命
              </Typography>
              <Typography variant="body1">
                致力於透過 AI 技術提升企業競爭力，讓智慧影像辨識技術成為工業 4.0
                轉型的重要推手
              </Typography>
            </StyledBox>
            <StyledBox>
              <Typography
                variant="subtitle1"
                style={{ marginBottom: '0.5rem' }}
              >
                我們的願景
              </Typography>
              <Typography variant="body1">
                成為全球領先的AI影像辨識解決方案供應商，幫助各行業實現更高效、更安全、更智能的未來
              </Typography>
            </StyledBox>
            <StyledBox>
              <Typography
                variant="subtitle1"
                style={{ marginBottom: '0.5rem' }}
              >
                核心價值{' '}
              </Typography>
              <Box style={{ marginBottom: !isPC ? '0.5rem' : 0 }}>
                <Typography variant="body1">
                  <StyleSpan>創新驅動 </StyleSpan>
                  {!isPC ? <br /> : ''}
                  —— 不斷研發前沿 AI 技術，提供業界領先的解決方案
                </Typography>
              </Box>
              <Box style={{ marginBottom: !isPC ? '0.5rem' : 0 }}>
                <Typography variant="body1">
                  <StyleSpan>精準高效 </StyleSpan>
                  {!isPC ? <br /> : ''}
                  —— 以高準確率的 AI 視覺辨識，確保生產品質與作業安全
                </Typography>
              </Box>
              <Box style={{ marginBottom: !isPC ? '0.5rem' : 0 }}>
                <Typography variant="body1">
                  <StyleSpan>客戶導向 </StyleSpan>
                  {!isPC ? <br /> : ''}
                  —— 以企業需求為核心，打造量身訂製的 AI 方案
                </Typography>
              </Box>
              <Box style={{ marginBottom: !isPC ? '0.5rem' : 0 }}>
                <Typography variant="body1">
                  <StyleSpan>持續優化 </StyleSpan>
                  {!isPC ? <br /> : ''}
                  —— 透過大數據與機器學習，不斷提升 AI 檢測能力
                </Typography>
              </Box>
            </StyledBox>
            <StyledBox>
              <Typography variant="body1">
                透過慧智瞳的 AI
                影像辨識技術，讓機器擁有智慧視覺，為企業開創更高效、更安全的未來！
              </Typography>
            </StyledBox>
          </div>
        </Grid>
        <Grid item xs={12}>
          <ContactMe />
        </Grid>
      </Grid>
    </MainLayout>
  )
}
